import { render, staticRenderFns } from "./NoGoAreasSettings.vue?vue&type=template&id=66e4d598&"
import script from "./NoGoAreasSettings.vue?vue&type=script&lang=js&"
export * from "./NoGoAreasSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports